var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#BCBFD0",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59091 10.625V11.125H7.09091H9.04545V12H7.09091H6.59091V12.5V14.8125H5.95455V12.5V12H5.45455H3.5V11.125H5.45455H5.95455V10.625V8.3125H6.59091V10.625ZM17.2273 8.75C17.2273 10.6118 15.9248 12 14.4545 12C12.9843 12 11.6818 10.6118 11.6818 8.75C11.6818 6.88817 12.9843 5.5 14.4545 5.5C15.9248 5.5 17.2273 6.88817 17.2273 8.75ZM8.40909 18.125C8.40909 17.1993 9.23192 16.384 10.5712 15.7693C11.8693 15.1734 13.4345 14.875 14.4545 14.875C15.4746 14.875 17.0398 15.1734 18.3379 15.7693C19.6772 16.384 20.5 17.1993 20.5 18.125V19.5H8.40909V18.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/AddUser.d4c5a1c9.svg";
export { ForwardRef as ReactComponent };